import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";

export default function CaseCard({ item }) {
  return (
    <div>
      <Link to={`/cases/${item.slug}`} className="group block" data-testid={`case-card-${item.slug}`}>
        <div className="overflow-hidden bg-muted aspect-[4/5]">
          <img
            src={item.cover_image}
            alt={item.title}
            loading="lazy"
            className="img-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
          />
        </div>
        <div className="mt-6 flex items-start justify-between gap-4">
          <div>
            <div className="flex items-center gap-3 text-xs uppercase tracking-label text-muted-foreground mb-2">
              <span>{item.location}</span>
              <span className="text-accent">&#9670;</span>
              <span>{item.year}</span>
            </div>
            <h3 className="font-display text-3xl md:text-4xl font-light leading-none">{item.title}</h3>
            <p className="mt-2 text-muted-foreground font-light max-w-md">{item.subtitle}</p>
          </div>
          <ArrowUpRight
            size={28}
            weight="light"
            className="shrink-0 mt-2 transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1"
          />
        </div>
      </Link>
    </div>
  );
}
